module.exports = __webpack_public_path__ + "img/Stanbic IBTC Bank Nigeria Limited.bc0f2d23.png";